import {type FC, Fragment} from 'react';

import {Paragraph} from '@/modules/foundation/components/typography/paragraph';

import {RadioTile} from '../../form/RadioTile';
import {FormattedItemPrice} from '../../item/FormattedItemPrice';

import type {PowerOutletConfig} from './configuration';
import type {PowerOutletType} from './query';

export type PowerOutletSelectorProps = {
	types: PowerOutletType[];
	maxQuantity: number;
	namePrefix: string;
	defaultConfig: PowerOutletConfig | null;
};

export const PowerOutletSelector: FC<PowerOutletSelectorProps> = ({
	types,
	maxQuantity,
	namePrefix,
	defaultConfig,
}) => {
	return (
		<fieldset>
			{Array.from({length: maxQuantity}, (_, index) => index).map((index) => (
				<Fragment key={index}>
					<Paragraph className="mb-2 font-semibold" asChild>
						<legend>Strømuttak {index + 1}</legend>
					</Paragraph>
					<div className="mb-4 flex flex-wrap gap-4">
						<RadioTile
							name={`${namePrefix}.${index}`}
							value="none"
							defaultChecked={!defaultConfig || defaultConfig[index] === null}
						>
							Ikke montert
						</RadioTile>
						{types.map((type) => (
							<RadioTile
								key={type._key}
								name={`${namePrefix}.${index}`}
								value={type._key}
								defaultChecked={
									!!defaultConfig && defaultConfig[index] === type._key
								}
							>
								{type.name}{' '}
								{type.items && type.items.length > 0 && (
									<>
										(+{' '}
										<FormattedItemPrice items={type.items}></FormattedItemPrice>
										)
									</>
								)}
							</RadioTile>
						))}
					</div>
				</Fragment>
			))}
		</fieldset>
	);
};
